module.exports = __webpack_public_path__ + "components/home-header/static/header-1--small-42eba24e904c5fc1d8006588b75a4b8c.jpg";